// Pure formatters: callers pass `now` explicitly (React components derive it
// from useNow so compiled renders stay fresh; see useNow.ts).
export function formatRelativeTime(timestamp: number, now: number): string {
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
}

// Countdown to a future timestamp, e.g. "in 23h" / "in 45m". Granular enough to
// be useful for short-lived things like a 24-hour credential.
export function formatTimeUntil(timestamp: number, now: number): string {
  const diff = timestamp - now;
  if (diff <= 0) return "expired";
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (minutes < 1) return "in <1m";
  if (minutes < 60) return `in ${minutes}m`;
  if (hours < 24) return `in ${hours}h`;
  return `in ${days}d`;
}
